<div [formGroup]="form" fxFlex="100" class="ckeditor-container">
    <mat-label class="label">{{ label }}</mat-label>
    <ckeditor 
        [editor]="balloonEditor" 
        [data]="value"
        (change)="onEditorChange($event)">
    </ckeditor>
</div>